import React, { FC } from 'react';

import type { TCamera, TInjector, TOption, TPlace, TPlan } from '~/src/features/videocontrol/Provider/types';
import { useRequisitionContext } from '~/src/features/videocontrol/Provider/useRequisitionContext';

import * as ST from './styled';

const MAX_COUNT = 99;

interface TProps {
    installLocation?: TPlace | null,
    camera?: TCamera | Record<string, never>,
    injector?: TInjector,
    plan?: TPlan | null,
    planOption?: TOption | null,
    title: string,
    withCounter?: boolean,
    onDeleteHandler?: (id: number) => void,
}

export const RequestPoint: FC<TProps> = ({
    installLocation,
    camera,
    plan,
    planOption,
    title,
    withCounter,
    onDeleteHandler,
    injector,
})=> {
    const { decrementCameraCountDispatch, incrementCameraCountDispatch } = useRequisitionContext();
    const data = installLocation || camera || plan || planOption || injector;

    if (!data || !Object.keys(data).length) {
        return null;
    }

    const { subService, name, service, currencyType, id } = data;
    const priceTotal = installLocation?.priceTotalWithCount || camera?.priceTotal || injector?.priceTotalWithCount;
    const priceMonth = plan?.priceMonthWithCount || camera?.priceMonth || planOption?.priceMonthWithCount;

    const incrementCameraHandler = (id: number) => {
        if (camera?.count === MAX_COUNT) {
            return;
        }
        incrementCameraCountDispatch(id);
    };

    const getPrice = (): number => {
        return Number(camera?.priceTotalWithCount || camera?.priceMonthWithCount || priceTotal || priceMonth);
    };

    return (
        <ST.Container>
            <ST.ShopTitle data-test={'title'}>{title}</ST.ShopTitle>
            <ST.WrapSubService>
                <ST.ProductNameWrap>
                    <ST.ProductName data-test={'name'}>{name}</ST.ProductName>
                    <ST.CounterWrap>
                        {onDeleteHandler && <ST.DeleteButton onClick={() => onDeleteHandler(id)}/>}
                    </ST.CounterWrap>
                </ST.ProductNameWrap>
                {subService && <ST.SubService data-test={'sub-service'}>{subService}</ST.SubService>}
            </ST.WrapSubService>
            {withCounter &&
                <ST.Counter data-test={'counter'} isDisabled={!!injector}>
                    <ST.Minus onClick={() => decrementCameraCountDispatch(id)}/>
                    <ST.CountValue data-test={'count-value'}>{camera?.count || injector?.count}</ST.CountValue>
                    <ST.Plus onClick={() => incrementCameraHandler(id)}/>
                </ST.Counter>
            }
            <ST.ServiceWrap>
                <ST.Service data-test={'service'}>{service}</ST.Service>
                <ST.PriceWrap>
                    <ST.Price data-test={'price'}>
                        {getPrice()} {currencyType}
                    </ST.Price>
                    {plan?.oldPrice && <ST.OldPrice data-test={'old-price'}>{plan?.oldPrice} {currencyType}</ST.OldPrice>}
                </ST.PriceWrap>
            </ST.ServiceWrap>
        </ST.Container>
    );
};
